import { writable, get } from 'svelte/store';
import { isNumeric } from './utils.js';

export let downloader = writable();
export let showDownloader = writable(false);

const storedDownloadJobs = JSON.parse(localStorage.getItem("downloadJobs"));
// Check for old jobs and remove them
for (let i = 0; i < storedDownloadJobs?.length; i++) {
    if ( Date.now() - storedDownloadJobs[i]?.started > 30 * 60 * 1000) {
        // Remove job if older than 2 minutes
        storedDownloadJobs.splice(i, 1);
        i--;
    }
}

export const downloadJobs = writable(storedDownloadJobs ? storedDownloadJobs : []);
downloadJobs.subscribe(jobs => {
    localStorage.setItem("downloadJobs", JSON.stringify(jobs));
});

export function addDownloadJob(job) {
    if ( !job ) return;
    if ( (typeof job) !== "object" ) return;
    if ( !job.started || !job.name || !isNumeric(job.minSlice) || !isNumeric(job.minSlice) ) return;

    // Generate a unique id for reference
    const uid = Date.now();
    job.uid = uid;

    downloadJobs.update(jobs => {
        jobs.push(job);
        return jobs;
    });
}

export function updateJob(job) {
    if (!job) return;
    if (!job.uid) return;
    
    const jobs = get(downloadJobs);
    if (!jobs) return;

    let dj = jobs.find((j) => j.uid === job.uid);
    if (!dj) return;

    job.modified = Date.now();
    dj = job;
    downloadJobs.update(jobs => [...jobs]);
}

export function interruptJob(job) {
    if (!job) return;
    if (!job.uid) return;

    const jobs = get(downloadJobs);
    if (!jobs) return;

    let dj = jobs.find((j) => j.uid === job.uid);
    if (!dj) return;

    job.modified = Date.now();
    job.interrupted = true;
    dj = job;
    downloadJobs.update(jobs => [...jobs]);
}

export function isJobInterrupted(job) {
    if (!job) return;
    if (!job.uid) return;

    const jobs = get(downloadJobs);
    if (!jobs) return;

    let dj = jobs.find((j) => j.uid === job.uid);
    if (!dj) return;

    return dj.interrupted === true;
}

// Stores loaded image data in memory as, e.g.
// {
//      slice_0_0009.jpg: {slice: 9, blob: <base64>},
//      slice_0_0010.jpg: {slice: 10, blob: <base64>}
// }
export let memcache = writable({});
export let memcacheProgress = writable({expectedCount: 0, count: 0});




